import { FONTS, COLORS } from 'constants/index';

const MuiAvatar = {
  rounded: {
    borderRadius: '8px',
    backgroundColor: `${COLORS.BLUE_DARK}66`,
    color: COLORS.BLUE_DARK,
    fontFamily: FONTS,
    fontWeight: 400,
    fontSize: '40px',
    lineHeight: '60px',
    width: '100px',
    height: '100px',
  }
};

export default MuiAvatar;
